import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedConversionUpsellStep =
  () => import(/* webpackChunkName: "conversion-upsell-step.async" */ './conversion-upsell-step')
    .then(({ ConversionUpsellStepWithI18n }) => ConversionUpsellStepWithI18n);

export const ConversionUpsellStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CONVERSION_UPSELL,
  view: DelayedConversionUpsellStep,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
    guards: {
      needsLoading: () => false,
      needsSaving: () => false,
    },
  },
};
